module.exports = __webpack_public_path__ + "static/best-support-464124542e2614020f46f16a4d8ecba0.svg";